/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Button, Checkbox, Col, Form, Input, Modal, Row, Select, Typography } from "antd";
import { FolderFilled, FolderOpenOutlined, FileZipOutlined, CaretDownOutlined, CaretRightOutlined, SearchOutlined,ExclamationCircleOutlined } from "@ant-design/icons";
import {  useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Loading } from "../../Common/components/Loading";
import axios from "axios";
import UploadPdfDoc from "./UploadPdfDoc";
import styles from "../style/DoraDocument.module.css"
import _ from "lodash";
import { listingContractTypes, customerDocsContractTypes } from "../../Common/commondata/commonData";
import { getBuildDataForCustomerdocs } from "../../CreateOffer/features/helperFunctions";
import CreateDoraDocsModal from "./CreateDoraDocsModal";
import { filteredTransactionData, formatAllSelerAgentsDetailsFun, formatPhoneNumber, getCoAgentsIds, getStreetAddress, removePersonObject } from "../../Common/utils/universalFuntions";
import { getCityFromFullAddress, getFullNamesFromArray } from "../../Common/utils/ExtraFunctions";
import { transactionLaneDataHandle } from "../state/actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { prepareCurrentAgentDetails, steetAddressDetailsPrepare } from "../utils/rtdHepler";
const { Text } = Typography;
const {Option} = Select;

const StyledTree = styled.div`
  line-height: 1.5;
`;
const StyledFile = styled.div`
  padding-left: px;
  display: flex;
  align-items: center;
  span {
    margin-left: 0px;
  }
`;
const StyledFolder = styled.div`
  padding-left: 0px;
  .folder--label {
    display: flex;
    align-items: center;
    span {
      margin-left: 0px;
    }
`;
const Collapsible = styled.div`
  height: ${(p) => (p.isOpen ? "0" : "auto")};
  overflow: hidden;
`;

const File = ({ name, selectedData, role, propertyDocs, insideFolder, section, handleCreateDocCancel, item, renderFrom, selectedFiles, setSelectedFiles, documentSets, setDocumentSets, isEditing, getTitleCompanySelectedData, userAuthKey }) => {
  const delegate = (section === "DELEGATE");
  const dispatch = useDispatch();
  const [isDoraDocsModalVisible, setIsDoraDocsModalVisible] = useState(false);
  const location = useLocation();
  const [isEmailPresent] = useState(false);
  const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);
  const [isHovered,setIsHovered] = useState(false);
  const history = useHistory();

  const { docSetTemplateData, docSetTemplateLoading } = useSelector((state) => state.rtdTransactionLane)

  const currentAgentDetails =  selectedData?.currentAgentId || {}
  const [ allData, setAllData ] = useState({
    uploadPdfDoc: false,
    file: "",
    ...(delegate ? {delegateSide: role, delegateOwnerId: currentAgentDetails?._id} : {}),
  })
 
  const urlShortHand = (ele) => {
    try {
      selectedData = filteredTransactionData({ selectedData, ele, source: "PROPERTY_DOCS" });
      let contractId = ele?.contractId?.pop();
      let prefillValues = ele?.prefillValues?.pop() || {};
      let allFormattedAgents = {};
      let transactionData = selectedData?.newTransactionData || selectedData?.transactionData || {};
      if (!selectedData.offerId && Array.isArray(selectedData?.offerSellerAgentIds) && selectedData?.offerSellerAgentIds.length) {
        allFormattedAgents = formatAllSelerAgentsDetailsFun({ offerSellerAgentIds: selectedData.offerSellerAgentIds, transactionData });
        transactionData["SellerAgents"] = allFormattedAgents?.SellerAgents;
      }
      const officeDetails = {
        officeLogo: currentAgentDetails?.brokerageData?.logo || "",
        name: currentAgentDetails?.brokerageData?.name?.trim() || "",
        address: currentAgentDetails?.brokerageData?.address || "",
        agentId: currentAgentDetails?._id,
      };
      if (customerDocsContractTypes.includes(ele?.contractType)) {
        const buildData = getBuildDataForCustomerdocs({ contractType: ele?.contractType, contractId, currentAgentDetails, transactionData, selectedData, delegate, item, officeDetails, userAuthKey });
        return dispatch(transactionLaneDataHandle.doraDocsUrlShorthandApiCalling({ buildData, history }));
      }
      let commonBuildData = {
        builtForId: currentAgentDetails?._id,
        key: currentAgentDetails?._id,
        builtForSection: "DOCUMENT",
        signable: true,
        openFor: "SELLER_AGENT",
        RTDInitiator: "SELLER",
        contractId,
        contractType: ele?.contractType,
        openForPropertyDoc: "SELLER_AGENT",
        ...(selectedData?.offerId && ele?.contractType !== "NET_SHEET" ? { offerId: selectedData?.offerId || "" } : {}),
        token: userAuthKey,
        ...(selectedData && selectedData.propertyId ? { propertyId: selectedData.propertyId } : {}),
        ...(delegate ? { delegateOwnerId: currentAgentDetails?._id } : {}),
      };

      if (["SA", "CB_NOCOLS"].includes(ele?.contractType)) {
        transactionData["BrokerName"] = currentAgentDetails?.fullName || "";
        transactionData["BrokerEmailAddress"] = currentAgentDetails?.email || "";
        transactionData["BrokerFirmName"] = currentAgentDetails.brokerageData.name || "";
        transactionData["BrokerFirmAddress"] = currentAgentDetails.brokerageData.address || "";
        transactionData["BrokerPhoneNumber"] = formatPhoneNumber(currentAgentDetails.mobilePhoneNumber.phoneNumber);
        transactionData["BrokerFaxNumber"] = formatPhoneNumber(currentAgentDetails.brokerageData.faxNumber);
      }
      let buildData = {
        ...commonBuildData,
        buyerAgentIds: getCoAgentsIds(selectedData?.buyerAgentIds),
        sellerAgentIds: getCoAgentsIds(selectedData?.sellerAgentIds),
        urlData: {
          ...(ele?.contractType !== "LCAES" && transactionData ? { ...transactionData } : {}),
          FullAddress: selectedData?.address,
          ...(ele?.contractType === "LCAES" && {
            LcaeCheckedListingContract: "ERTSListingContract",
            LcaeInitatingParty: "LcaeInitatingPartySeller",
            ...(selectedData?.ertsData ? { ...selectedData.ertsData } : {}),
            ...(selectedData?.ertsData?.SellerAgents ? {} : { SellerAgents: transactionData?.SellerAgents }),
            ...(selectedData?.addressDetails && { ...selectedData.addressDetails }),
          }),
          ...(typeof prefillValues === "object" && { ...prefillValues }),
          ...(selectedData?.sellerIds?.length > 0 ? { Sellers: removePersonObject(selectedData?.sellerIds) } : {}),
          ...(selectedData?.buyerIds?.length > 0 ? { Buyers: removePersonObject(selectedData?.buyerIds) } : {}),
          ...(["CB_NOCOLS"].includes(ele?.contractType)
            ? {
                ...(selectedData?.ertsData?.CompensationSaleCommissionPercentage ? { CompensationSaleCommissionPercentage: selectedData?.ertsData?.CompensationSaleCommissionPercentage } : {}),
                TitleCompanyName: getTitleCompanySelectedData?.titleCompanyName || "",
                TitleCloserName: getTitleCompanySelectedData?.titleCloserName || "",
                TitleCloserEmail: getTitleCompanySelectedData?.titleCloserEmail || "",
                TitleCloserPhone: formatPhoneNumber(getTitleCompanySelectedData?.titleCloserPhone) || "",
                SalesRepName: getTitleCompanySelectedData?.salesRepName || "",
                SalesRepEmail: getTitleCompanySelectedData?.salesRepEmail || "",
                SalesRepPhone: formatPhoneNumber(getTitleCompanySelectedData?.salesRepPhone) || "",
              }
            : {}),
          ...(["CRE_RE", "CRE_LA"].includes(ele?.contractType)
            ? {
                StreetAddress: getStreetAddress(selectedData?.address),
                City: getCityFromFullAddress(selectedData?.address),
                ...(ele?.contractType === "CRE_RE" && { BuyerBrokersList: getFullNamesFromArray(selectedData?.buyerAgentIds) }),
                ...(ele?.contractType === "CRE_LA" && { SellerBrokersList: getFullNamesFromArray(selectedData?.sellerAgentIds) }),
              }
            : {}),
          officeDetails,
        },
      };

      if (["CB_SAEFPT", "DC_TAC"].includes(ele.contractType)) {
        buildData.urlData.Buyers = [];
        buildData.urlData.Sellers = [];
      }
      if (["DC_ADBA", "DC_BCLA", "DC_CLASLC"].includes(ele?.contractType)) {
        const { agentArray } = prepareCurrentAgentDetails({ currentAgentDetails, contractType: ele?.contractType });
        delete buildData.buyerAgentIds;
        delete buildData.sellerAgentIds;
        if (ele.contractType === "DC_ADBA") {
          buildData.urlData.BuyerAgents = [];
          buildData.urlData.SellerAgents = agentArray;
        } else {
          buildData.urlData.BuyerAgents = transactionData.BuyerAgents?.slice(0, 2) ?? [];
          buildData.urlData.SellerAgents = ele.contractType === "DC_CLASLC" ? agentArray : transactionData.SellerAgents?.slice(0, 2) ?? [];
        }
      }
      // console.log("buildData", buildData);
      localStorage.setItem("openModal", JSON.stringify(true));
      dispatch(transactionLaneDataHandle.doraDocsUrlShorthandApiCalling({ buildData, history }));
    } catch (error) {
      console.log("error while creating a new document", error);
    }
  };  

  const handleCheckboxChange = (checked, item) => {
    if (checked) {
      dispatch(transactionLaneDataHandle.getDocTemplateData({contractType: item?.contractType, userAuthKey}));
      setSelectedFiles((prev) => [...prev, item?._id])
      setDocumentSets((prev) => [...prev, {contractId: item?.contractId?.[item?.contractId?.length - 1], contractType: item?.contractType}])
    } else {
      setSelectedFiles((prev) => prev.filter((fileId) => fileId !== item?._id))
      setDocumentSets((prev) => prev.filter((ele) => ele?.contractType !== item?.contractType))
    }
  }

  const handleSelectChange = (value, item) => {
    setDocumentSets((prev) =>
    prev.map((docSet) =>
      docSet?.contractType === item?.contractType
        ? { ...docSet, templateId: value }
        : docSet
      )
    );
  }

  let docInRtd = false;
  propertyDocs?.forEach((el) => {
    if (el.documentName === name.name) {
      docInRtd = true;
    }
  });

  let str = name.name;

  let span1 = "";
  let span2 = "";
  if (str.length > 24) {
    str = str.substr(0, 24);
    var lastSpace = str.lastIndexOf(" ");
    if (!lastSpace) {
      lastSpace = str.lastIndexOf("/");
    }
    if (lastSpace !== -1) {
      span1 = str.substr(0, lastSpace);
      span2 = name.name.substr(lastSpace, name.name.length);
    }
  } else {
    span1 = name.name;
  }

  const handleCreateNew = () => {
  if((name?.contractType === "INSP_RESOL") && (propertyDocs?.filter((el) => el?.contractType === "INSP_OBJ")?.length <= 0)){
            Modal.confirm({
                title:"Warning! An inspection objection document should exist before creating an inspection resolution document! Are you sure you want to proceed?",
                okText:"Yes",
                cancelText:"No",
                icon: <ExclamationCircleOutlined />,
                onOk: () => {
                    urlShortHand(name)
                },
                onCancel: () => {
                    handleCancel()
                }
            })
        }else{
          urlShortHand(name);
        }
 
  };

  const handleUploadNew = () => {
    setAllData({
      ...allData,
      uploadPdfDoc: true,
    })
  }

  const handleModalCancel = () => {
    setAllData({
      ...allData,
      uploadPdfDoc: false
    })
  }
  const handleCancel = () => {
    setIsDoraDocsModalVisible(false)
    };

  return (
    <>
      {/* create Dora Docs Modal */}
      {isDoraDocsModalVisible && (
        <CreateDoraDocsModal
          isDoraDocsModalVisible={isDoraDocsModalVisible}
          setIsDoraDocsModalVisible={setIsDoraDocsModalVisible}
          selectedData={selectedData}
          element={name}
          handleCreateNew={handleCreateNew}
          handleUploadNew={handleUploadNew}
        />
      )}
      <UploadPdfDoc
        selectedData={{ ...selectedData, ...name, RTDInitiator: role }}
        getCoordinateItem={item}
        allData={allData}
        setAllData={setAllData}
        handleModalCancel={handleModalCancel}
        open={allData?.uploadPdfDoc}
        successFuncAll={handleCreateDocCancel}
      />
      <StyledFile
        style={{
          pointerEvents: listingContractTypes.includes(name?.contractType) ? "none" : "auto",
          opacity: listingContractTypes.includes(name?.contractType) ? 0.6 : 1,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <span
            style={{
              fontSize: "18px",
              fontWeight: 500,
              textAlign: "left",
              color: docInRtd ? "rgb(110 153 214)" : "#b0b0b0",
              width: "100%",
              marginTop: "4px",
              marginLeft: insideFolder ? "21px" : "auto",
              paddingLeft: 0,
              display: "flex",
              alignItems: "center",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {renderFrom ? (
              selectedFiles?.includes(name?._id) || isHovered ? (
                <Checkbox
                  style={{ marginRight: "5px" }}
                  checked={selectedFiles?.includes(name?._id)}
                  onChange={(e) => handleCheckboxChange(e.target.checked, name)}
                />
              ) : (
                <FileZipOutlined
                  style={{
                    fontSize: "20px",
                    cursor: "pointer",
                    marginRight: "5px",
                  }}
                />
              )
            ) : (
              <FileZipOutlined
                style={{
                  fontSize: "20px",
                  cursor: "pointer",
                  marginRight: "5px",
                }}
              />
            )}
            <span
              id="fileNameContainer"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                if (!renderFrom) {
                  if (!isEmailPresent) {
                    setIsDoraDocsModalVisible(true)
                  } else {
                    setIsEmailModalVisible(true)
                  }
                }
              }}
            >
              {span1}
              {span2}
            </span>
          </span>
          {selectedFiles?.includes(name?._id) && (
            <div
              style={{
                marginTop: "8px",
                marginLeft: insideFolder ? "35px" : "",
                zIndex: 10,
              }}
            >
              <Select
                style={{ width: 200 }}
                placeholder="Select a template"
                onChange={(value) => handleSelectChange(value, name)}
                allowClear
              >
                {docSetTemplateLoading ? <Loading/> : docSetTemplateData &&
                  docSetTemplateData?.filter((ele) => ele?.contractType === name?.contractType)?.map((element, index) => {
                    return (
                      <Option key={index} value={element?._id}>
                        {element?.templateName}
                      </Option>
                    );
                })}
              </Select>
            </div>
          )}
        </div>
      </StyledFile>
    </>
  );
};
// its an folder structure component
const Folder = ({ name, children, fiters, userAuthKey }) => {
  const [isOpen, setIsOpen] = useState(fiters?.search?.trim() ? true : false);
  const handleToggle = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <StyledFolder>
      <div
        className="folder--label"
        onClick={handleToggle}
        style={{
          cursor: "pointer",
        }}
      >
        {isOpen ? (
          <>
          <CaretDownOutlined
            style={{
                fontSize: "1.3rem",
                marginRight: "5px",
                color: "rgb(107,152,199)",
            }}
          />{" "}
            <FolderOpenOutlined style={{ fontSize: "20px", color: "rgb(107,152,199)" }} />
          </>
        ) : (
          <>
            <CaretRightOutlined style={{ fontSize: "1.3rem", color: "#8C8C8C" }} />
            <FolderFilled
              style={{
                fontSize: "20px",
                color: "rgb(107,152,199)"
              }}
            />
          </>
        )}
        <span
          style={{
            fontSize: "19px",
            fontWeight: 600,
            color: "#8C8C8C",
            marginTop: "4px",
            paddingLeft: "4px",
          }}
        >
          {name}
        </span>
      </div>
      <Collapsible isOpen={!isOpen}>{children}</Collapsible>
    </StyledFolder>
  );
};

const Tree = ({ children }) => {
  return <StyledTree>{children}</StyledTree>;
};

Tree.File = File;
Tree.Folder = Folder;

export default function CreateDocs({ role, item, section, handleCreateDocCancel,loading, renderFrom, selectedFiles, setSelectedFiles, isEditing, documentSets, setDocumentSets, handlePropertyDocs, userAuthKey }) {
  const dispatch = useDispatch();
  const { getPreDoraDocumentsData, getPreDoraDocumentsLoading, getPreDoraDocumentsError, propertyDocs } = useSelector((state) => state.rtdTransactionLane);

  const { getIndividualTransactionData, getTitleCompanySelectedData } = useSelector((state) => state.rtdTransactionLane);
  const { getUserDetailsData } = useSelector((state) => state.account);
   const [fiters, setFilters] = useState({search: ""});
    const [form] = Form.useForm();
    let unmounted = {
      value: false
    };
    let source = axios.CancelToken.source();
    const handleClear = ({ renderWithClear }) => {
        form.resetFields();
        setFilters({
            search: ""
        })
    }
    useEffect(()=>{
      let data = {
        listType: role,
        ...(item?.offerId ? { offerId: item?.offerId }: {}),
      };
      dispatch(transactionLaneDataHandle.getPreDoraDocumentsData({data, unmounted, source, fiters, brokerageId: getUserDetailsData?.brokerageData?.brokerageId?._id, userAuthKey}));

      return () => {
        unmounted.value = true;
        source.cancel("Cancelling in cleanup");
      }
    }, [fiters])

  // useEffect(() => {
  //   if (getIndividualTransactionData?.offerId && ((["ACCEPTED", "TERMINATED", "DRAFT", "SUBMITTED"].includes(getIndividualTransactionData?.status)))) {
  //   //   dispatch(transactionLaneDataHandle.getTitleCompanyData({ offerId: getIndividualTransactionData.offerId, source, unmounted }));
  //     return () => {
  //       unmounted.value = true;
  //       source.cancel("Cancelling in cleanup");
  //     }
  //   }
  // }, [getIndividualTransactionData])
 

  //debounce logic to call search api
    const debouncedFunction = _.debounce((value) => {
        setFilters({
            search: value
        })
    }, 1000);

    const handleSearch = (event) => {
        const value = event.target.value;
        debouncedFunction(value);
    };

  return (
    <div style={{ height: "calc(85vh - 8rem)", display: "flex", flexDirection: "column",width:"100%" }}>

      <Row style={{ width: "100%", flexWrap: "nowrap", justifyContent: "center", gap: 5 }}>
        <Col className={styles.searchInputBoxCol}>
          <div className={styles.searchInputBox}>
            <Form form={form} initialValues={{}}>
              <Form.Item name="search">
                <Input
                  allowClear
                  placeholder="Search here..."
                  suffix={<SearchOutlined />}
                  onChange={handleSearch}
                  size="middle"
                />
              </Form.Item>
            </Form>
          </div>
        </Col>
        <Col>
          <div className={styles.sortBox}>
            <Button
              style={{
                background: "#3a74b6",
                color: "whitesmoke",
                fontWeight: "bold",
                border: "none",
                padding: "0 10px"
              }}
              onClick={handleClear}
            >
              <div>Reset</div>
            </Button>
          </div>
        </Col>
      </Row>
      {loading || getPreDoraDocumentsLoading  ? (
        <Loading />
      ) : getPreDoraDocumentsError ? "" : (
        <Row span={24} style={{ height: renderFrom ? "54vh" : "50vh", overflowY: "auto", marginBottom: "5px" }}>
          <Col
            span={24}
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
              {(getPreDoraDocumentsData?.length > 0) ?
                <Tree>
                  {getPreDoraDocumentsData.map((ele) => {
                    if (ele.doc_second.length > 0) {
                      return (
                        <Tree.Folder key={ele._id} fiters={fiters} name={ele.name} documentSets={documentSets} userAuthKey={userAuthKey} style={{ cursor: "pointer" }}>
                          {ele.doc_second.map((element) => {
                            return <Tree.File key={element._id} name={element} selectedData={getIndividualTransactionData || item} item={item} role={role} propertyDocs={propertyDocs} insideFolder={true} section={section} handleCreateDocCancel={handleCreateDocCancel} renderFrom={renderFrom} selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} isEditing={isEditing} documentSets={documentSets} setDocumentSets={setDocumentSets} getTitleCompanySelectedData={getTitleCompanySelectedData} userAuthKey={userAuthKey}  />;
                          })}
                        </Tree.Folder>
                      );
                    } else return <Tree.File key={ele._id} name={ele} selectedData={getIndividualTransactionData || item} item={item} role={role} propertyDocs={propertyDocs} insideFolder={false} section={section} handleCreateDocCancel={handleCreateDocCancel} renderFrom={renderFrom} selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} isEditing={isEditing} documentSets={documentSets} setDocumentSets={setDocumentSets} getTitleCompanySelectedData={getTitleCompanySelectedData} userAuthKey={userAuthKey} />
                  })}
                </Tree> :
                (role === "BROKERAGE_DOC" && getPreDoraDocumentsData?.length === 0) ?
                  <div style={{ textAlign: "center", width: '100%', fontSize: "large"}}>
                    <Text>No Brokerage Forms available for your Brokerage.</Text>
                  </div> : ""
              }
          </Col>
        </Row>
      )}
    </div>
  );
}
